import * as React from 'react';

function SvgComponent(props, ref) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 505 505" {...props} ref={ref}>
      <circle cx={252.5} cy={252.5} r={252.5} fill="#90dfaa" />
      <path
        d="M365.4 130.2v275.1H180.2c-16.9 0-30.6-13.7-30.6-30.6V130.2h-32V99.6h217.2c16.9.1 30.6 13.7 30.6 30.6z"
        fill="#fff"
      />
      <g fill="#e6e9ee">
        <path d="M119.1 99.7c-16.9 0-30.6 13.7-30.6 30.6h61.1c.1-17-13.6-30.6-30.5-30.6zM393.5 374.8c0 16.9-13.7 30.6-30.6 30.6H180.2c16.9 0 30.6-13.7 30.6-30.6h182.7z" />
      </g>
      <path
        d="M358.4 168.1c-20.2 8.2-38.3 17.5-40.2 18.6 9.5-3.1 20.5-7.1 31.9-11-6.3 5.6-12.5 11.4-18.4 17-25.8 12-61 34-63.3 36.1 14.8-6.9 33.3-16 50.9-24.2-9.3 9-17.8 17.6-25.3 24.9-.5.5-1 1.1-1.6 1.6-23.1 10.6-48 25.8-50.2 27.4 11.9-5.1 26.3-11.6 40.6-17.8-24.2 24.5-41.7 30.5-75.8 49.8.3-44.4 2.5-68.5 40.4-107.5 1.2-1.2 2.4-2.3 3.5-3.5-8.7 18.2-14.6 37.2-16.9 52.2.7-2.8 11.8-35.8 28.2-62.5 19.8-17 46.3-33.3 73.5-43.5-9.3 8.6-17.4 17.6-23.4 25.7 1.6-1.6 15.6-15.7 33.9-29.5 26.3-8.6 52-11.2 70.2-7.9-14 16.4-36.4 34.6-58 54.1z"
        fill="#324a5e"
      />
      <path
        d="M324.4 159.1c-3.2 1.7-7 4-11.2 6.6-4.3 2.7-9 5.8-14 9.5-5 3.6-10.4 7.7-15.8 12.3s-11 9.6-16.5 15.1c-5.4 5.5-10.8 11.5-15.9 17.8a480.8 480.8 0 00-15.2 19.4c-9.9 13.2-18.9 27.1-26.4 40.7-7.6 13.5-13.8 26.7-18.6 38.2-9.7 23-13.9 39.4-14 39.3.3.1.6.2 1 .3.1 0 5.5-15.9 16.3-38.1 5.5-11.1 12.4-23.7 20.5-36.6 8.2-12.9 17.5-26.2 27.7-38.8 5.1-6.2 10.4-12.3 15.9-18.1s10.9-11.3 16.3-16.6c5.3-5.3 10.5-10.4 15.5-15.2s9.8-9.3 14.3-13.3c4.5-4.1 8.7-7.8 12.5-11 3.7-3.3 7.1-6.1 9.8-8.4 5.5-4.6 8.6-7.3 8.6-7.3-.2-.3-.4-.6-.5-.8-.2-.2-4 1.5-10.3 5z"
        fill="#acb3ba"
      />
      <path fill="#2b3b4e" d="M255.4 306.5h69.2v22h-69.2z" />
      <path
        d="M344.8 405.3H235.1c-1.2 0-2.1-.9-2.1-2.1V327c0-1.2.9-2.1 2.1-2.1h109.6c1.2 0 2.1.9 2.1 2.1v76.2c.1 1.2-.9 2.1-2 2.1z"
        fill="#ff7058"
      />
      <path fill="#e6e9ee" d="M248.1 342.5h98.8v45.3h-98.8z" />
    </svg>
  );
}
const WorkingTitleIcon = React.forwardRef(SvgComponent);
export default WorkingTitleIcon;
